import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import apiClient from "@/utils/api";
import { useCustomerAuth } from "@/context/CustomerAuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setCustomer } = useCustomerAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await apiClient.post("/customer-auth/session", { session_id: sessionId });
        setCustomer(data.user);
        // Strip fragment and go to /account
        window.history.replaceState(null, "", "/account");
        navigate("/account", { replace: true, state: { user: data.user } });
      } catch (e) {
        console.error("Sign-in failed", e);
        navigate("/?signin=failed", { replace: true });
      }
    })();
  }, [navigate, setCustomer]);

  return (
    <div data-testid="auth-callback-loading" className="min-h-[60vh] flex flex-col items-center justify-center gap-3 text-stone-500">
      <Sparkles className="w-6 h-6 text-[#D4AF37] animate-pulse" />
      <p className="text-sm">Signing you in with Google…</p>
    </div>
  );
}
